import React from 'react';
import { Box, Typography, Button, Paper, styled } from '@mui/material';

const FormContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2, 2, 3, 2),
  marginBottom: theme.spacing(2),
  borderRadius: theme.spacing(2),
  backgroundColor: "#fff",
  border: "1px solid rgba(255, 152, 0, 0.3)",
  boxShadow: "0 4px 12px rgba(255, 152, 0, 0.15)",
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(4),
    marginBottom: theme.spacing(3),
  },
}));

const NfeFormContainer = ({ onOpenPrintTypeModal, children }) => {
  return (
    <FormContainer elevation={0}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
        <Button
          variant="outlined"
          color="warning"
          size="small"
          onClick={onOpenPrintTypeModal}
          sx={{ fontWeight: 600, borderRadius: 2 }}
        >
          Alterar tipo de impressão
        </Button>
      </Box>
      
      <Box
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          mb: { xs: 2, md: 3 },
        }}
      >
        <Typography
          variant={{ xs: "h5", md: "h4" }}
          gutterBottom
          sx={{
            fontWeight: 700,
            color: "#ff9800",
            mb: 1.5,
            fontSize: { xs: "1.5rem", md: "2rem" },
            fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
            letterSpacing: "-0.025em",
            textShadow: "0 1px 2px rgba(255, 152, 0, 0.1)",
          }}
        >
          Impressão de Etiquetas NFe
        </Typography>

        <Typography
          variant={{ xs: "body1", md: "h6" }}
          sx={{
            color: "text.secondary",
            fontSize: { xs: "1rem", md: "1.125rem" },
            px: { xs: 1, md: 0 },
            fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            lineHeight: 1.6,
            opacity: 0.8,
          }}
        >
          Digite ou escaneie a chave da NF-e para imprimir a etiqueta
        </Typography>
      </Box>

      {children}
    </FormContainer>
  );
};

export default NfeFormContainer;